import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Commune } from 'src/app/utils/interfaces/new/commune.interface';

@Injectable({
  providedIn: 'root'
})
export class GeoService {

  public apiUrl = 'https://geo.api.gouv.fr';

  constructor(private http: HttpClient) { }

  // Méthode pour rechercher les communes par nom
  searchCommunesByName(name: string): Observable<Commune[]> {
    return this.http.get<Commune[]>(`${this.apiUrl}/communes?nom=${name}&fields=codesPostaux,departement&boost=population&limit=50`);
  }

  // Méthode pour rechercher les communes par code postal
  searchCommunesByPostalCode(postalCode: string): Observable<Commune[]> {
    return this.http.get<Commune[]>(`${this.apiUrl}/communes?codePostal=${postalCode}&fields=codesPostaux,departement`);
  }

  // Méthode pour rechercher les communes par code INSEE
  searchCommunesByINSEECode(inseeCode: string): Observable<Commune[]> {
    return this.http.get<Commune[]>(`${this.apiUrl}/communes?code=${inseeCode}&fields=codesPostaux,departement`);
  }
}
